import { useCallback, useEffect, useReducer } from "react";
import { getCreditHistory, getTrailStatus } from "../api/credithistory.api";
import {
  creditHistoryInitialState,
  creditHistoryReducer,
} from "./creditHistory.reduser";
import { setCreditHistory, setTotal } from "./creditHistory.action";
import { toUtcIsoDateTime } from "../../../../../utils/datetime";

export const useCreditHistoryViewModel = () => {
  const [state, dispatch] = useReducer(
    creditHistoryReducer,
    creditHistoryInitialState,
  );

  const getCreditHistoryData = useCallback(async () => {
    try {
      // dispatch({ type: "SET_LOADING", payload: true });

      const offset = (state.currentPage - 1) * state.pageSize;

      const resp = await getCreditHistory({
        startDate:
          state.isSearched && state.startDate
            ? toUtcIsoDateTime(state.startDate)
            : undefined,
        endDate:
          state.isSearched && state.endDate
            ? toUtcIsoDateTime(state.endDate)
            : undefined,
        limit: state.pageSize,
        offset: offset,
      });
      console.log("Credit History Response:", resp);
      dispatch(setCreditHistory(resp.data.transactions));
      dispatch(setTotal(resp.data.total));
    } catch (error) {
      console.error("Error fetching credit history:", error);
    } finally {
      //  dispatch({ type: "SET_LOADING", payload: false });
    }
  }, [
    state.currentPage,
    state.pageSize,
    state.startDate,
    state.endDate,
    state.isSearched,
  ]);
  const handleTrialStatus = useCallback(async () => {
    try {
      const storedUser = localStorage.getItem("user");
      const persona = storedUser ? JSON.parse(storedUser)?.persona : null;

      if (persona === "super_admin" || persona === "job_seeker") {
        return null;
      }

      const resp = await getTrailStatus();
      console.log("Trial Status Response:", resp);
      dispatch({ type: "SET_TRIAL_STATUS", payload: resp.data });
      return resp.data; // Return the trial status data
    } catch (error) {
      console.error("Error fetching trial status:", error);
    }
  }, []);
  useEffect(() => {
    getCreditHistoryData();
    handleTrialStatus();
  }, [
    state.currentPage,
    state.pageSize,
    state.isSearched,
    state.searchVersion,
  ]);
  return {
    state,
    dispatch,
    getCreditHistoryData,
    handleTrialStatus,
  };
};
